import { Component, Input, OnInit } from '@angular/core';
import { format } from 'date-fns';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

import { ReviewStat } from '~/core/model/review-stats.model';
import { OrganizationService } from '~/core/services/organization/organization.service';
import { LocaleService } from '~/i18n/services/locale.service';
import { VtmnButtonVariantEnum } from '~/component/buttons/vtmn-button/enum/vtmn-button-variant.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-organizer-description',
  templateUrl: './organizer-description.component.html',
  styleUrls: ['./organizer-description.component.scss'],
})
export class AttendeeOrganizerDescriptionComponent implements OnInit {
  @Input() public createdAt: Date;
  @Input() public description: string;
  @Input() public id: string;
  @Input() public logo: string;
  @Input() public name: string;

  public readonly vtmnButtonVariant = VtmnButtonVariantEnum;
  public reviewCount: number;
  public averageRating: number;

  public readonly icon = VtmnPlayIconTypeEnum;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly localeService: LocaleService,
    private readonly organizationService: OrganizationService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.organizationService
        .getOrganizationReviewsStats(this.id)
        .subscribe((stats: ReviewStat) => {
          this.reviewCount = stats?.count;
          this.averageRating = stats?.averageRating;
        })
    );
  }

  get formattedCreatedAtDate(): string {
    return this.createdAt
      ? format(new Date(this.createdAt), 'dd/MM/y', {
          locale: this.localeService.dateLocale,
        })
      : '';
  }
}
